import { createAction, props } from '@ngrx/store';
import { ManureOfferModel } from 'src/app/offer/models/manure-offer.model';

export const offerMakeMatch = createAction(
  '[Request] Make match on selected offer',
  props<{ offerId: number; intermediary: string }>(),
);

export const offerMakeMatchSuccess = createAction(
  '[Request] Make match on selected offer success',
  props<{ response: ManureOfferModel }>(),
);

export const offerMakeMatchFailure = createAction(
  '[Request] Make match on selected offer failure',
  props<{ error: string }>(),
);
